(function () {
  if (window.__pqMotionInit) return;
  window.__pqMotionInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initProgressBar() {
    var bar = document.getElementById('pq-scroll-progress');
    if (!bar) return;
    var ticking = false;
    function update() {
      var doc = document.documentElement;
      var scrollTop = window.pageYOffset || doc.scrollTop;
      var height = (doc.scrollHeight - doc.clientHeight) || 1;
      var pct = Math.min(Math.max((scrollTop / height) * 100, 0), 100);
      bar.style.width = pct + '%';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initStickyBar() {
    var bar = document.querySelector('[data-pq-stickybar]');
    if (!bar) return;
    if (window.sessionStorage && sessionStorage.getItem('pqStickyBarDismissed') === '1') return;
    var showAfter = window.innerHeight * 0.9;
    var ticking = false;
    function update() {
      if (window.pageYOffset > showAfter) {
        bar.classList.add('is-shown');
      } else {
        bar.classList.remove('is-shown');
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
    var closeBtn = bar.querySelector('[data-pq-stickybar-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.classList.remove('is-shown');
        if (window.sessionStorage) sessionStorage.setItem('pqStickyBarDismissed', '1');
      });
    }
  }

  function initMagnetic() {
    if (reduceMotion) return;
    var els = document.querySelectorAll('.pq-magnetic');
    els.forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var rect = el.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        el.style.transform = 'translate(' + (x * 0.16).toFixed(1) + 'px,' + (y * 0.26).toFixed(1) + 'px)';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transform = 'translate(0,0)';
      });
    });
  }

  function init() {
    initProgressBar();
    initStickyBar();
    initMagnetic();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
